import {Directive, HostListener, Input} from '@angular/core';

/**
 * Generated class for the ValidateInputDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[validate-input]' // Attribute selector
})
export class ValidateInputDirective {

  @Input() limitLength: number = 30;
  @Input() alphanumerical: boolean = false;
  @Input() loginCase: boolean = false;

  constructor() {
  }

  @HostListener('keypress', ['$event'])
  onkeypress(ev) {
    if (ev.target.value.length === this.limitLength) {
      ev.preventDefault();
    } else {
      if(this.alphanumerical) {
        let regString;
        if (this.loginCase)
          regString = "[a-zA-Z0-9@\\-_.]";
        else
          regString = "[a-zA-Z0-9]";
        let regExpression =  new RegExp(regString);
        if (!regExpression.test(ev.key)) {
          ev.preventDefault();
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/validate-input/validate-input.ts